import { createContext, useContext, useState, useEffect } from "react";
import { createSession } from "../services/api_base";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  const login = async (email, password) => {
    const response = await createSession(email, password);
    if (response.data) {
      setToken(response.data.access_token);
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("name", response.data.user.name);
      localStorage.setItem("userId", response.data.user.id);
      localStorage.setItem("idUnidade", response.data.user.id_unidade);
      localStorage.setItem("nomeUnidade", response.data.unidade);
      localStorage.setItem("idPerfil", response.data.user.id_perfil)
      navigate(`/home/`);
    } else {
      console.error("Falha na autenticação:", response.data.error);
    }
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("userId");
    localStorage.removeItem("idUnidade");
    localStorage.removeItem("nomeUnidade");
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
